import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import AlertDownload from '../../container/AlertDownload';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.registration.label.name',
    description: 'Page Header Title',
    defaultMessage: 'User Registration'
  },
  headerSubTitle: {
    id: 'approve.page.title',
    description: 'Page Header Subtitle',
    defaultMessage: 'Approval'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});


const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

class Link2approverequestpage extends Component {

  componentDidMount() {

    //this.props.getuser(this.props.memberusername);

    this.props.getQuotbypo(this.props.quotation_id);
    this.props.gotopage();

  }

  // componentWillUnmount() {
  //   console.log('I  am in componentWillUnMount ');
  //   //this.props.getuser(this.props.match.params.id);
  //   sessionStorage.setItem('tptpg', '/approve');
  // }

  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
        />
        <AlertDownload
          title="Approve Account Error"
          body="Invalid Username."
          message={print(this.props.status)}
        />
      <Footer />
    </div>
    );
  }
}

Link2approverequestpage.propTypes = {
  getuser: PropTypes.func.isRequired,
  locale: PropTypes.string,
  intl: PropTypes.object,
  status: PropTypes.object
};

export default injectIntl(Link2approverequestpage);



// WEBPACK FOOTER //
// ./src/components/views/Link2approverequestpage/index.js